import React, { Component } from 'react';

class Link extends Component {
  render() {
    const { label, url } = this.props.block;
    return (
      <a href={url} className='middle-navigator-link-container'>
        {label}
      </a>
    );
  }
}

export default Link;
